import React, { useState } from "react";
import SalesReports from "./SalesReports";
import { useTranslation } from "react-i18next";
import ExpensesReports from "./expensesreprt/ExpensesReports";
import { CardHeadeWithActions } from "../ui";

const Reports = () => {
  const { t } = useTranslation("global");
  const [tabActive, setTabActive] = useState("reports");
  const reportsIcon = "/assets/icons/Reportl.png";

  return (
    <div className="flex flex-col">
      <CardHeadeWithActions>
        <div className="w-[100%] mb-0 flex justify-between items-center">
          <div className="title flex justify-center gap-1 items-center">
            <img className="w-5 z-50" src={reportsIcon} alt="Reports" />
            <span className="text-[#261759] ms-1 font-bold">
              {t("menu.Reports")}
            </span>
          </div>
        </div>
      </CardHeadeWithActions>
      <div className="w-full mt-3 bg-[#F8FAFC] rounded-md p-1 flex gap-2">
        <button
          onClick={() => setTabActive("reports")}
          className={`px-4 py-2 text-sm rounded-md font-bold transition ${
            tabActive === "reports"
              ? "bg-[#EBF9D9] text-[#261759]"
              : "bg-white text-[#261759]"
          }`}
        >
          {t("reports.bonds_reports")}
        </button>
        <button
          onClick={() => setTabActive("expenses")}
          className={`px-4 py-2 text-sm rounded-md font-bold transition ${
            tabActive === "expenses"
              ? "bg-[#EBF9D9] text-[#261759]"
              : "bg-white text-[#261759]"
          }`}
        >
          {t("reports.expenses_reports")}
        </button>
      </div>
      {tabActive === "reports" && <SalesReports />}
      {tabActive === "expenses" && <ExpensesReports />}
    </div>
  );
};

export default Reports;
